export var CARD_TYPES = Object.freeze({
  primary: 'primary',
  secondary: 'secondary'
});